const countries = [
    {
        key: 'co',
        emoji: '🇨🇴'
    },
    {
        key: 'ar',
        emoji: '🇦🇷'
    },
    {
        key: 'pe',
        emoji: '🇵🇪'
    },
    {
        key: 'ec',
        emoji: '🇪🇨'
    },
    {
        key: 'us',
        emoji: '🇺🇸'
    },
    {
        key: 'ca',
        emoji: '🇨🇦'
    },
    {
        key: 'bo',
        emoji: '🇧🇴'
    },
    {
        key: 'ur',
        emoji: '🇺🇾'
    },
    {
        key: 'cr',
        emoji: '🇨🇷'
    },
    {
        key: 'rd',
        emoji: '🇩🇴'
    },
    {
        key: 'br',
        emoji: '🇧🇷'
    },
    {
        key: 'cl',
        emoji: '🇨🇱'
    },
    {
        key: 'mx',
        emoji: '🇲🇽'
    },
    {
        key: 'pa',
        emoji: '🇵🇦'
    },
    {
        key: 've',
        emoji: '🇻🇪'
    },
    {
        key: 'es',
        emoji: '🇪🇸'
    },
    {
        key: 'in',
        emoji: '🇮🇳'
    },
    {
        key: 'no',
        emoji: '🇳🇴'
    },
    {
        key: 'hu',
        emoji: '🇭🇺'
    },
    {
        key: 'cz',
        emoji: '🇨🇿'
    },
    {
        key: 'li',
        emoji: '🇱🇮'
    },
    {
        key: 'il',
        emoji: '🇮🇱'
    },
    {
        key: 'ae',
        emoji: '🇦🇪'
    },
    {
        key: 'pl',
        emoji: '🇵🇱'
    },
    {
        key: 'gb',
        emoji: '🇬🇧'
    },
    {
        key: 'cy',
        emoji: '🇨🇾'
    },
    {
        key: 'cn',
        emoji: '🇨🇳'
    },
    {
        key: 'uk',
        emoji: '🇬🇧'
    },
    {
        key: 'de',
        emoji: '🇩🇪'
    },
    {
        key: 'sc',
        emoji: '🇸🇨'
    },
    {
        key: 'jo',
        emoji: '🇯🇴'
    },
    {
        key: 'au',
        emoji: '🇦🇺'
    },
    {
        key: 'li',
        emoji: '🇱🇮'
    },
]

export default countries;
